import React, { useState } from 'react';
// @ts-ignore
import styles from './WorkplaceHealthPlansSetupItem.module.scss';
import CheckboxField from '../../../../../../Components/Form/components/CheckboxField';
import useTranslation from '../../../../../../Hooks/useTranslation';
import FormContainer from '../../../../../../Components/Form/FormContainer';

export interface IWorkplaceHealthPlansSetupItem {
	id: string;
	name: string;
	code: string;
	active: boolean;
	description?: string;
	settings?: {
		consentTerms: {
			name: string;
			url: string;
		}[];
	};
}

interface Props {
	item: IWorkplaceHealthPlansSetupItem;
}

const WorkplaceHealthPlansSetupItem: React.FC<Props> = ({ item }) => {
	const [isActive, setIsActive] = useState(item.active);
	const { t } = useTranslation();

	return (
		<div className={styles.item}>
			<div className={styles.header}>
				<CheckboxField
					name={`${item.id}_active`}
					customOnChange={() => setIsActive(prev => !prev)}
				/>
				<div className={styles.title}>{item.name}</div>
			</div>
			{isActive && (item.settings?.consentTerms?.length || 0) > 0 && (
				<div className={styles.consents}>
					<FormContainer name={`${item.id}_consents`}>
						{item.settings?.consentTerms?.map((consent, index) => {
							return (
								<div className={styles.consent} key={index}>
									<CheckboxField name={`${item.id}_consent_${index}`} />
									<div>
										{t('appShared.iAmFamiliarAndIAgreeWith')}{' '}
										<a href={consent.url} target='_blank'>
											{t(consent.name)}
										</a>
									</div>
								</div>
							);
						})}
					</FormContainer>
				</div>
			)}
		</div>
	);
};

export default WorkplaceHealthPlansSetupItem;
